import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { clearCategoryActionCreator, setCategoryActionCreator } from '../states/categories/actions';

const CategoryItem = ({ category }) => {
  const dispatch = useDispatch();
  const { categories = {} } = useSelector((states) => states);
  const onClickCategory = () => {
    dispatch(setCategoryActionCreator(category));
  };

  const onClearCategory = () => {
    dispatch(clearCategoryActionCreator());
  };

  const isCategorySelected = categories?.selectedCategory === category;

  return isCategorySelected ? (
    <button type="button" className="py-1.5 px-2.5 rounded-full font-normal text-sm bg-[#1682FD] text-white" onClick={onClearCategory}>
      #
      {category}
    </button>
  ) : (
    <button type="button" className="py-1.5 px-2.5 rounded-full font-normal text-sm bg-[#EAEAEA] text-[#808080]" onClick={onClickCategory}>
      #
      {category}
    </button>
  );
};

CategoryItem.propTypes = {
  category: PropTypes.string.isRequired,
};

export default CategoryItem;
